import React from "react";

import styles from "./Hero.module.scss";
import backgroundImage from "../../../assets/images/hero.jpg";

class Hero extends React.PureComponent {
  public render() {
    return (
      <div
        className={styles.main}
        style={{
          backgroundImage: `url(${backgroundImage})`,
        }}
      >
        <div className={styles.mask} />
        <div className={styles.overMask}>
          <p className={styles.heroText}>
            <span className={styles.breakPoint}>全ての就活生が</span>
            <span className={styles.breakPoint}>
              <strong className={styles.bold}>本質的な</strong>キャリアを
            </span>
            <br />
            通じて人生を<strong className={styles.bold}>最大化</strong>する
          </p>
        </div>
      </div>
    );
  }
}

export default Hero;
